type QuotesIconProps = {
  className?: string;
  fill?: string;
};

export const QuotesIcon = ({
  className = "",
  fill = "#fff",
}: QuotesIconProps): React.ReactElement => (
  <svg
    fill={fill}
    className={`${className} text-black`}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="26"
    viewBox="0 0 22 26"
  >
    <g id="Group_6544" data-name="Group 6544" transform="translate(-35 -486)">
      <g id="Group_6501" data-name="Group 6501">
        <g
          id="Group_6481"
          data-name="Group 6481"
          transform="translate(11400 -9425)"
        >
          <g
            id="Rectangle_1980"
            data-name="Rectangle 1980"
            transform="translate(-11365 9911)"
            fill={fill}
            stroke={fill}
            strokeWidth="1"
          >
            <rect width="22" height="26" rx="5" stroke="none" />
            <rect x="0.5" y="0.5" width="21" height="25" rx="4.5" fill="none" />
          </g>
        </g>
        <g id="Group_6547" data-name="Group 6547">
          <line
            id="Line_362"
            data-name="Line 362"
            x2="14.671"
            transform="translate(38.829 503.301)"
            fill="none"
            stroke="#000"
            strokeWidth="1"
          />
          <line
            id="Line_363"
            data-name="Line 363"
            x2="14.671"
            transform="translate(38.829 507.262)"
            fill="none"
            stroke="#000"
            strokeWidth="1"
          />
          <path
            id="ic_local_atm_24px"
            d="M13.653,18.733h2.13V17.668h1.065A1.068,1.068,0,0,0,17.913,16.6v-3.2a1.068,1.068,0,0,0-1.065-1.065h-3.2V11.276h4.261V9.146h-2.13V8.081h-2.13V9.146H12.587a1.068,1.068,0,0,0-1.065,1.065v3.2a1.068,1.068,0,0,0,1.065,1.065h3.2v1.065H11.522v2.13h2.13Z"
            transform="translate(31.282 480.896)"
          />
        </g>
      </g>
    </g>
  </svg>
);
